import { render, staticRenderFns } from "./VehicleRegistration.vue?vue&type=template&id=2922a571"
import script from "./VehicleRegistration.vue?vue&type=script&lang=ts"
export * from "./VehicleRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports